export enum Payment {
  NORMAL = 'NORMAL',
  SALARY = 'SALARY',
}
